import axios from "axios";
import userHooks from "./userHooks";
import { URL } from "../constants";
const apiClient = axios.create({
  baseURL: URL,
  timeout: 10000,
});

apiClient.defaults.withCredentials = false;

apiClient.interceptors.request.use(
  async (config) => {
    const getToken = window.sessionStorage.getItem("accessToken");
    config.headers["Content-Type"] = "application/json";
    config.headers.Authorization = getToken;
    return config;
  },
  function (error) {
    // return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  async function (response) {
    if (response.data.expired) {
      const getToken = window.sessionStorage.getItem("refreshToken");
      // api 요청 추후 작업
      const res = await userHooks.issuedTokenHooks({ token: getToken });
      // if (res.IsError) {
      //   window.sessionStorage.removeItem("accessToken");
      //   window.sessionStorage.removeItem("refreshToken");
      //   window.location.href = "/login";
      // }
      if (!res.data.status) {
        window.sessionStorage.removeItem("accessToken");
        window.sessionStorage.removeItem("refreshToken");
        window.location.href = "/login";
      }
      window.sessionStorage.setItem("accessToken", res.data.access_token);
      response.config.headers.Authorization = res.data.access_token;
      return apiClient(response.config);
    } else {
      return response;
    }
  }
  // function (error) {
  //   window.sessionStorage.removeItem("accessToken");
  //   window.sessionStorage.removeItem("refreshToken");
  //   window.location.href = "/login";
  //   return Promise.reject(error);
  // }
);

export { apiClient };
